export interface ChartThemeOverrides {
  fixLeftEdge?: boolean
  fixRightEdge?: boolean
  scaleMargins?: { top: number; bottom: number }
}

export function getChartThemeOptions(theme: string, overrides?: ChartThemeOverrides) {
  const isDark = theme === 'dark'
  return {
    layout: {
      background: { type: 'solid' as const, color: isDark ? '#181818' : '#fefefe' },
      textColor: isDark ? '#F1F5F9' : '#212b36',
      attributionLogo: false,
    },
    grid: {
      vertLines: { color: isDark ? '#2A2A2A' : '#f0f0f0' },
      horzLines: { color: isDark ? '#2A2A2A' : '#f0f0f0' },
    },
    crosshair: {
      mode: 0 as const,
      vertLine: {
        color: isDark ? 'rgba(147,197,253,0.4)' : 'rgba(70,130,180,0.5)',
        width: 1 as const,
        style: 3 as const,
        labelVisible: true,
        labelBackgroundColor: isDark ? '#374151' : '#4682B4',
      },
      horzLine: {
        color: isDark ? 'rgba(147,197,253,0.4)' : 'rgba(70,130,180,0.5)',
        width: 1 as const,
        style: 3 as const,
        labelVisible: true,
        labelBackgroundColor: isDark ? '#374151' : '#4682B4',
      },
    },
    rightPriceScale: {
      borderColor: isDark ? '#383838' : '#dcdee0',
      scaleMargins: overrides?.scaleMargins ?? { top: 0.1, bottom: 0.15 },
    },
    handleScale: {
      mouseWheel: false,
      pinch: true,
      axisPressedMouseMove: true,
      axisDoubleClickReset: true,
    },
    timeScale: {
      timeVisible: true,
      secondsVisible: false,
      borderColor: isDark ? '#383838' : '#dcdee0',
      fixLeftEdge: overrides?.fixLeftEdge ?? true,
      fixRightEdge: overrides?.fixRightEdge ?? true,
    },
  }
}

export function binarySearchClosest<T extends { time: number }>(items: T[], targetTs: number): number {
  if (items.length === 0) return 0
  let lo = 0
  let hi = items.length - 1
  while (lo < hi) {
    const mid = (lo + hi) >> 1
    if (items[mid].time < targetTs) lo = mid + 1
    else hi = mid
  }
  if (lo > 0 && Math.abs(items[lo - 1].time - targetTs) < Math.abs(items[lo].time - targetTs)) {
    return lo - 1
  }
  return lo
}
